export default __webpack_public_path__ + "guide--raster-sakurajima-480-121cf1565886ef995b0d000af4089f08.webp";